import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { AgendarTarefaComponent } from 'src/app/shared/components/detalhes-obra/agendar-tarefa/agendar-tarefa.component';
import { SidePanelComponent } from 'src/app/shared/components/side-panel/side-panel.component';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { environment } from 'src/environments/environment';
import { FichaDaObraService } from '../service/ficha-da-obra.service';
import { TarefasRelatosService } from '../tarefas-relatos/tarefas-relatos.service';
import { ModalReportarErroContatoComponent } from 'src/app/shared/components/modais/modal-reportar-erro-contato/modal-reportar-erro-contato.component';

@Component({
  selector: 'app-contatos',
  standalone: true,
  imports: [
    CommonModule,
    AgendarTarefaComponent,
    SidePanelComponent,
    ModalReportarErroContatoComponent,
  ],
  templateUrl: './contatos.component.html',
  styleUrl: './contatos.component.scss',
})
export class ContatosComponent {
  @Input() idObra: number | null = null;
  @Input() idModulo: number | null = null;
  @Input() workName: string = '';
  @Input() moduleName: string = '';
  @Input() companyId: number | null = null;
  @Input() companyName: string = '';

  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  @Output() loading = new EventEmitter<boolean>();

  isPanelOpen = false;
  panelTitle = 'Agendar Tarefa';
  contatoSelecionado: any = null;
  currentPanel: string | null = null;
  isLoadingObra: boolean = false;
  contatos: any = {};
  showReportContato = false;
  contatoParaReport: any = null;
  empresaParaReport: any = null;

  private readonly subscriptions: Subscription = new Subscription();
  private readonly _errorHandleService = inject(ErrorHandleService);
  private readonly _tarefasRelatosService = inject(TarefasRelatosService);
  private lastIdObraConsulted: number | null = null;

  constructor(private readonly _fichaDaObraService: FichaDaObraService) {}

  ngOnInit(): void {
    if (this.idObra && this.idModulo && this.idObra !== this.lastIdObraConsulted) {
      this.listarContatosObra();
      this.lastIdObraConsulted = this.idObra;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['idObra'] || changes['idModulo']) && this.idObra && this.idModulo) {
      this.listarContatosObra();
      this.lastIdObraConsulted = this.idObra;
    }
  }

  listarContatosObra() {
    this.isLoadingObra = true;
    const subscription = this._fichaDaObraService
      .listarContatosObra(this.idObra!, this.idModulo!)
      .subscribe({
        next: (res) => {
          this.contatos = res.data;
          this.isLoadingObra = false;
        },
        error: (err) => {
          this._errorHandleService.throwConsoleError(err);
          this.isLoadingObra = false;
        },
      });
    this.subscriptions.add(subscription);
  }

  abrirAgendarTarefa(contato: any) {
    this.contatoSelecionado = {
      cargo: contato.titulo || contato.contactRole,
      nome: contato.nome || contato.contactName,
      email: contato.emails?.[0]?.endereco || contato.contactEmail || '',
      id: contato.contactId || null,
    };
    this.isPanelOpen = true;
    this.panelTitle = 'Agendar Tarefa';
    this.currentPanel = 'agendar-tarefa';
  }

  abrirReportContato(contato: any, empresa: any): void {
    this.contatoParaReport  = contato;
    this.empresaParaReport  = empresa;
    this.showReportContato  = true;
  }

  fecharReportContato(): void {
    this.showReportContato = false;
    this.contatoParaReport = null;
    this.empresaParaReport = null;
  }

  closePanel() {
    this.isPanelOpen = false;
    this.contatoSelecionado = null;
  }

  atualizarListaTarefas(novaTarefa: any) {
    this._tarefasRelatosService.emitirAtualizacao();
    this.closePanel();
  }

  onPainelLoading(status: boolean) {
    this.loading.emit(status);
    this.isLoadingObra = status;
  }

  getWhatsappLink(phoneNumber: string | null | undefined): string {
    if (!phoneNumber) return '';
    return `https://wa.me/${phoneNumber.replace(/\D/g, '')}`;
  }

  getStatusDotColor(color: string): string {
    switch (color) {
      case 'green':  return '#64FFC8';
      case 'orange': return '#FEC298';
      case 'gray':   return '#B1BBC2';
      default:       return '';
    }
  }

  getExternalUrl(url: string): string {
    if (!url) return '';
    return /^https?:\/\//i.test(url) ? url : 'https://' + url.replace(/^\/+/, '');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}